import { useState, useEffect } from "react";
import {
  Card,
  Button,
  Container,
  Row,
  Col,
  InputGroup,
  FormControl,
  Table,
  DropdownButton,
  Dropdown,
  Accordion,
} from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../utils/constant";
import AdminModal from "../../components/Modals/AdminModel";

import Loader from "../../components/Loader";
import {
  MdArrowBackIos,
  MdArrowForwardIos,
  MdCancel,
  MdCheckCircle,
} from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaEdit, FaUserCircle } from "react-icons/fa";
import ReactPaginate from "react-paginate";

const Admin = () => {
  const [showAdminModal, setShowAdminModal] = useState(false);
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editAdminData, setEditAdminData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [itemOffset, setItemOffset] = useState(0);
  const [exportLoading, setExportLoading] = useState(false);

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/users/tms_users/?role=admin`,
        {
          headers: HEADERS,
        }
      );
      if (response.data && response.data.results) {
        setAdmins(response.data.results);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleEditAdmin = (admin) => {
    setEditAdminData(admin);
    setShowAdminModal(true);
  };

  const handleToggleActive = async (adminId, currentStatus) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/users/tms_users/${adminId}/`,
        { is_active: !currentStatus },
        {
          headers: {
            ...HEADERS,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        toast.success(
          `Admin ${currentStatus ? "deactivated" : "activated"} successfully!`
        );
        fetchAdmins();
      } else {
        toast.error("Failed to update Admin status. Please try again.");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } else {
          toast.error("Unexpected error format. Please try again.");
        }
      } else {
        toast.error("Error Please Try again.");
      }
    }
  };

  const handleCloseModals = () => {
    setShowAdminModal(false);

    setEditAdminData(null);
  };

  const handleSearchTextChange = (e) => {
    const searchText = e.target.value.toLowerCase();
    setSearchText(searchText);
    setItemOffset(0);
    filterAdmins(searchText);
  };

  const filterAdmins = (searchText) => {
    if (searchText === "") {
      fetchAdmins();
    } else {
      const filtered = admins.filter(
        (admin) =>
          admin.first_name?.toLowerCase().includes(searchText) ||
          admin.last_name?.toLowerCase().includes(searchText) ||
          admin.id?.toString().includes(searchText)
      );
      setAdmins(filtered);
    }
  };

  const handlePageClick = (selectedItem) => {
    const newOffset = selectedItem.selected * itemsPerPage;
    setItemOffset(newOffset);
  };

  const itemsPerPage = 10;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = admins.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(admins.length / itemsPerPage);

  const handleExport = async () => {
    setExportLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/export-admins/`, {
        headers: {
          ...HEADERS,
          "Content-Type": "application/json",
        },
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "admins.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("Admins exported successfully!");
    } catch (error) {
      toast.error("Failed to export Admins. Please try again.");
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <Container fluid className="mt-5">
      <Card>
        <Card.Header>
          <div className="d-flex align-items-center">
            <div>
              <h4 className=" me-5 mb-0">Admins </h4>
            </div>

            <div className="me-2 mb-2 mb-md-0">
              <InputGroup>
                <FormControl
                  type="text"
                  value={searchText}
                  placeholder="Search Admin "
                  onChange={handleSearchTextChange}
                />
              </InputGroup>
            </div>
            <div className="d-none d-lg-flex">
              <Button
                variant="primary"
                onClick={() => setShowAdminModal(true)}
                className="me-2 mb-1"
              >
                + Add Admin
              </Button>
              {/* <Button
                variant="primary"
                onClick={() => setShowImportModal(true)}
                className="me-2 mb-1"
              >
                Import
              </Button> */}
              <Button
                variant="primary"
                onClick={handleExport}
                className="me-2"
                disabled={exportLoading}
              >
                {exportLoading ? "Exporting..." : "Export"}
              </Button>
            </div>
          </div>

          <Accordion className="d-lg-none">
            <Accordion.Item eventKey="0">
              <Accordion.Header>Actions</Accordion.Header>
              <Accordion.Body>
                <Button
                  variant="primary"
                  onClick={() => setShowAdminModal(true)}
                  className="me-2 mb-1"
                >
                  + Add Admin
                </Button>
                {/* <Button
                  variant="primary"
                  onClick={() => setShowImportModal(true)}
                  className="me-2 mb-1"
                >
                  Import
                </Button> */}
                <Button
                  variant="primary"
                  onClick={handleExport}
                  className="me-2"
                  disabled={exportLoading}
                >
                  {exportLoading ? "Exporting..." : "Export"}
                </Button>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Card.Header>
        <Card.Body>
          <div className="table-responsive">
            {loading ? (
              <Loader />
            ) : (
              <Table responsive hover>
                <thead style={{ fontWeight: "bold" }}>
                  <tr>
                    {/* <th>
                      <input type="checkbox" onChange={handleSelectAll} />
                    </th> */}
                    <th>Name</th>
                    <th>Email</th>
                    <th>Contact Number</th>
                    {/* <th>Check-In Time</th>
                    <th>Check-out Time</th> */}
                    <th>Status</th>
                    {/* <th>Battery Status</th>
                    <th>GPS Status</th> */}
                  </tr>
                </thead>
                <tbody>
                  {currentItems.length > 0 ? (
                    currentItems.map((admin) => (
                      <tr key={admin.id} style={{ cursor: "pointer" }}>
                        {/* <td>
                          <input
                            type="checkbox"
                            checked={selectedAdmins.includes(
                              admin.id
                            )}
                            onChange={(e) => handleSelect(e, admin.id)}
                          />
                        </td> */}
                        <td>
                          <div className="d-flex align-items-center">
                            <span className="service-id badge bg-primary text-white me-2">
                              {admin.id}
                            </span>
                            {admin.profile_image ? (
                              <img
                                src={admin.profile_image}
                                alt="Profile"
                                className="rounded-circle border me-2"
                                style={{ width: "30px", height: "30px" }}
                              />
                            ) : (
                              <FaUserCircle
                                size={30}
                                className="text-primary me-2"
                              />
                            )}
                            <div>
                              {admin.first_name} {admin.last_name}
                            </div>
                          </div>
                        </td>
                        <td>{admin.email}</td>
                        <td>{admin.phone_number || "None"}</td>
                        {/* <td>
                      
                          {formatTime(admin.today_attendance?.check_in) ||
                            "NA"}
                        </td>
                        <td>
                          {formatTime(admin.today_attendance?.check_out) ||
                            "NA"}
                        </td> */}
                        <td>
                          {/* {admin.today_attendance?.status || "absent"} */}

                          <span
                            className={`badge ${
                              admin.is_active ? "bg-success" : "bg-danger"
                            }`}
                          >
                            {admin.is_active ? "Active" : "Inactive"}
                          </span>
                        </td>

                        {/* <td>
                              <span className="service-id badge bg-primary text-white">
                                {amc.id}
                              </span>
                              <br />
                              {amc.amcName}
                            </td> */}
                        {/* 
                        <td>
                          {admin.battery_status
                            ? admin.battery_status + "%"
                            : "NA"}
                        </td>
                        <td>{admin.gps_status ? "On" : "Off"}</td> */}
                        <td>
                          <div className="ms-auto">
                            <DropdownButton
                              id="dropdown-basic-button"
                              title={<BsThreeDotsVertical />}
                              variant="link"
                              className="p-0 text-secondary custom-dropdown"
                            >
                              <Dropdown.Item
                                onClick={() => handleEditAdmin(admin)}
                              >
                                <FaEdit className="me-2" /> Edit
                              </Dropdown.Item>
                              <Dropdown.Item
                                as="button"
                                onClick={() =>
                                  handleToggleActive(admin.id, admin.is_active)
                                }
                              >
                                {admin.is_active ? (
                                  <>
                                    <MdCancel className="me-2" /> Deactivate
                                  </>
                                ) : (
                                  <>
                                    <MdCheckCircle className="me-2" /> Activate
                                  </>
                                )}
                              </Dropdown.Item>
                            </DropdownButton>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center">
                        No Admins Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            )}
          </div>
          {currentItems.length > 0 && (
            <Row className="justify-content-end">
              <Col>
                <ReactPaginate
                  breakLabel="..."
                  nextLabel={<MdArrowForwardIos />}
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={5}
                  pageCount={pageCount}
                  previousLabel={<MdArrowBackIos />}
                  renderOnZeroPageCount={null}
                  className="pagination justify-content-end"
                  activeLinkClassName={
                    itemOffset === 0 || itemOffset ? "activeLink" : ""
                  }
                  forcePage={Math.ceil(pageCount / currentItems.length - 1)}
                />
              </Col>
            </Row>
          )}
        </Card.Body>
      </Card>

      {showAdminModal && (
        <AdminModal
          show={showAdminModal}
          handleClose={handleCloseModals}
          adminData={editAdminData}
          fetchAdmins={fetchAdmins}
        />
      )}
    </Container>
  );
};

export default Admin;
